module.exports = __webpack_public_path__ + "img/logo_ydp_w@2x.19c20a38.png";